'use strict';
import i18n from 'i18next';
import 'regenerator-runtime/runtime';
import { api } from '../../utils/api-interceptor';

let servicesContact = (() => {
  let init = (e) => llamarServicio(e);

  const llamarServicio = async (e) => {
    const urlApi =
      `static_pages?slug=${i18n.t('contact')}&temporal=` +
      Math.floor(Math.random() * 1000);

    try {
      const data = await api(urlApi, { hasLang: true });
      return data.content;
    } catch (error) {}
  };

  return {
    init: (e) => init(e),
  };
})();

export { servicesContact };
